import React from "react";

/* components */
import ModalWrapper from "components/common/Modal";
import SignIn from "modules/auth/SignIn";
import SignUp from "modules/auth/SignUp";

/* styles */
import classes from "components/partials/Header/ActionsBlock/Unauthorized/index.module.scss";
import Button from "../../../../ui/Button/base";

import Icon from "components/common/Icon";

import { useTranslation } from "react-i18next";

const UnauthorizedActions = () => {
  const { t } = useTranslation("header_volunteering");

  return (
    <div className={classes.wrapper}>
      <div style={{ display: "flex", alignItems: "center" }} className="mr-4">
        <Icon
          iconFolder="user-dropdown"
          iconName="help-center"
          className="mr-2"
        />
        <p
          onClick={() => (window.location.href = "/help-center")}
          style={{ cursor: "pointer" }}
        >
          {t("userDDHelpCenter")}
        </p>
      </div>

      <ModalWrapper
        modalName="sign-in"
        headerTitle="Sign In"
        buttonClasses="mr-4"
        buttonSpacing="mr-4"
        buttonSize="small"
        onlySignInModal
        trigger={
          <Button type="button" text="signInBtn" spacing="mr-4" size="small" />
        }
      >
        <SignIn />
      </ModalWrapper>

      <ModalWrapper
        modalName="sign-up"
        headerTitle="Sign Up"
        buttonText="Sign Up"
        buttonSize="small"
        trigger={
          <Button type="button" text="signUpBtn" spacing="mr-4" size="small" />
        }
      >
        <SignUp />
      </ModalWrapper>
    </div>
  );
};

export default UnauthorizedActions;
